export default __webpack_public_path__ + "static/nft3-bca1ffd3af5436e59fb518c8c63fc814.png";